export default "__VITE_ASSET__ab0d4b83__"